import React from 'react'
import './InventoryViewerModal.css'
import Text from '@amzn/meridian/text'
import Icon from '@amzn/meridian/icon'
import collapseTokens from '@amzn/meridian-tokens/base/icon/collapse'
import Button from '@amzn/meridian/button'
import { useDispatch } from 'react-redux'
import { setInventoryViewerModalHidden } from '@src/redux/slices/inventoryViewerModalSlice'
import { IVFrameId, InventoryViewerModalUtils } from '@src/utils/InventoryViewerModalUtils'
import { useBundle } from '@amzn/react-arb-tools'
import { BUNDLE_NAME } from '@src/constants'
import { t } from '@src/translationHelper'

interface IInventoryViewerModalPropsInterface {
    isIVModalOpen: boolean
}

export const InventoryViewerModal = (props: IInventoryViewerModalPropsInterface) => {
    const { isIVModalOpen } = props
    const [bundle] = useBundle(BUNDLE_NAME)
    const dispatch = useDispatch()
    const onClose = () => {
        dispatch(setInventoryViewerModalHidden())
        InventoryViewerModalUtils.sendIVEvent('closeIVEvent', 'modal')
        InventoryViewerModalUtils.sendEventToToolIframe('closeIVEvent', 'ATBase')
    }
    const inventoryViewerURL: string = InventoryViewerModalUtils.getUrl()
    return (
        <div className={isIVModalOpen ? 'modal-overlay' : 'modal-overlay hidden'}>
            <div className={isIVModalOpen ? 'modal' : 'modal hidden'}>
                <div className="topdiv">
                    <div className="divflex">
                        <div className="modal-header">
                            <Text color="inverted" type="h200">{t(bundle, 'jsma-web-navbar-inventoryViewer')}</Text>
                            <Button data-testid="CollapseButton" onClick={onClose} type="link" size="small">
                                <Icon className={'token'} tokens={collapseTokens} />
                            </Button></div>
                    </div>
                    <iframe id={IVFrameId} height={'91.5%'} width={'100%'} title={t(bundle, 'jsma-web-navbar-inventoryViewer')} className={'iframe'} src={inventoryViewerURL} />
                </div>
            </div>
        </div>
    )
}
